import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import BaseListContainer from '../../../baseContainers/BaseListContainer';
import ActionLink from '../../../components/ActionLink';
import CriteriaCalendarRangeComponent from '../../../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaTextComponent from '../../../components/criteria/CriteriaTextComponent';
import AuthService from '../../../services/AuthService';
import UserVoucherService from '../../../services/UserVoucherService';
import Constants from '../../../utils/constants';
import YesNoDialog from '../../../components/YesNoDialog';
import { Button, Menu } from 'primereact';

class UserVoucherListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserVoucherService());
        this.state = {
            ...this.state,
            list: [],
            loading: true,
            criteria: this.getCleanSearchCriteria(),
            dialogVisible: false,
            refundDialogVisible: false,
            elementId: null,
        };
        this.authService = new AuthService();
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleOpenRefundDialog = this.handleOpenRefundDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            user: criteria.user,
            voucher : criteria.voucher,
            voucherCode: criteria.voucherCode,
            locale: criteria.locale,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            user: '',
            voucher: '',
            voucherCode: '',
            locale: this.authService.getI18n(),
            dateFrom: undefined,
            dateTo: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'buyTime',
            sortAsc: false
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return '';
    }
    getCriteriaName() {
        return 'user-voucher-list-sc';
    }

    getContainerListName() {
        return 'user-voucher-list-container';
    }

    renderCriteria() {
        return (
            <div>
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='user'
                    label={t('user-voucher.username')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.user}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                </div>
                <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='voucher'
                    label={t('user-voucher.voucher')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.voucher}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                </div>
                <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='voucherCode'
                    label={t('user-voucher.voucher_code')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.voucherCode}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                </div>
                <div class="row">
                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    maxDateInfinite
                    placeholderFrom={t('voucher.dateFrom')}
                    placeholderTo={t('voucher.dateTo')}
                    inputsClassName='col-6'
                />
            </div>
            </div>
        );
    }

    handleOpenDialog(e, id) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisible: true, elementId: id });
    }

    handleOpenRefundDialog(e, id) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ refundDialogVisible: true, elementId: id });
    }

    handleCloseDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisible: false, elementId: null });
    }

    prepareColumns() {
        return [
            {
                field: 'id',
                header: t('ID'),
                sortable: true,
            },
            {
                field: 'status.label',
                header: t('voucher.status'),
                sortable: false,
            },
            {
                field: 'qrCode.voucher.title',
                header: t('voucher.title'),
                sortable: false,
            },
            {
                field: 'buyTime',
                header: t('user-voucher.buyTime'),
                body: this.dateTemplate.bind(this, 'buyTime', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                field: 'validUntil',
                header: t('user-voucher.validTime'),
                body: this.dateTemplate.bind(this, 'validUntil', Constants.DATE_TIME_FORMAT),
                sortable: true,
            },
            {
                field: 'costed',
                header: t('voucher.cost'),
                sortable: false,
            },
            {
                field: 'user.email',
                header: t('user-voucher.user'),
                sortable: false,
            },
            {
                key: 'actions',
                float: 'center',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef(); // Poprawiona inicjalizacja
    
        const menuItems = [
            {
                label: t('user-voucher.confirm-voucher-use'),
                icon: 'pi pi-check',
                command: () => this.handleOpenDialog(null, rowData.id),
            },
            {
                label: t('user-voucher.confirm-refund'),
                icon: 'pi pi-refresh',
                command: () => this.handleOpenRefundDialog(null, rowData.id),
            },
        ];
    
        return rowData.status.value === 'OPEN' ? (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items "
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        ) : null;
    }
    //override
    actionTemplate2(rowData) {
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
        return (
            rowData.status.value==='OPEN' ?
            <div>
                <ActionLink
                    alt={t('user-voucher.confirm-voucher-use')}
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenDialog(e, rowData.id)}
                    variant='blue'
                    iconName='mdi-cart-check'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
                <span></span>
                <ActionLink
                    alt={t('user-voucher.confirm-refund')}
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenRefundDialog(e, rowData.id)}
                    variant='blue'
                    iconName='mdi-cash-refund'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
            : null
        );
    }

    breadCrumbItems() {
        return [{name: t('user-voucher.listTitle'), url: '/user-purchased-list'}];
    }
    render() {
        return (
            <div className='container-fluid'>
                {this.state.dialogVisible ? (
                    <YesNoDialog
                    onChange={this.archive.bind(this)}
                    visible={this.state.dialogVisible}
                    header={t('user-voucher.confirm-archive-title')}
                    name='visible'
                    onHide={() => {
                        this.setState({ dialogVisible: false });
                    }}
                    yesButtonClassName='red-button'
                >
                    {t('user-voucher.confirm-archive-details')}
                </YesNoDialog>
                ) : null}
                  {this.state.refundDialogVisible ? (
                    <YesNoDialog
                    onChange={this.refund.bind(this)}
                    visible={this.state.refundDialogVisible}
                    header={t('user-voucher.confirm-refund-title')}
                    name='visible'
                    onHide={() => {
                        this.setState({ refundDialogVisible: false });
                    }}
                    yesButtonClassName='red-button'
                >
                    {t('user-voucher.confirm-refund-details')}
                </YesNoDialog>
                ) : null}
                {this.renderView()}
            </div>
        );
    }

    refund(type, costam, target) {
        if (target.value) {
            this.blockUi();
            if (this._isMounted) {
                this.service
                    .refund(this.state.elementId)
                    .then(() => {
                        ;
                        this.unblockUi();
                        this.showSuccessMessage('', '', t('user-voucher.refund-success'));   
                        this.setState({refundDialogVisible: false});
                        this.refreshTable();
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({refundDialogVisible: false});
                        this.unblockUi();
                    });
            } else {
                this.setState({refundDialogVisible: false});
            }            
        }else{
            this.setState({refundDialogVisible: false});
        }
    }

    archive(type, costam, target) {
        if (target.value) {
            this.blockUi();
            if (this._isMounted) {
                this.service
                    .archive(this.state.elementId)
                    .then(() => {
                        ;
                        this.unblockUi();
                        this.showSuccessMessage('', '', t('user-voucher.archive-success'));   
                        this.setState({dialogVisible: false});
                        this.refreshTable();
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({dialogVisible: false});
                        this.unblockUi();
                    });
            } else {
                this.setState({dialogVisible: false});
            }            
        }else{
            this.setState({dialogVisible: false});
        }
    }
}

UserVoucherListContainer.defaultProps = {
    detailUrl: '/voucher/details',
    newUrl: '/voucher/create',
    editUrl: '/voucher/edit',
    lazy: true,
};

UserVoucherListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserVoucherListContainer));
